





































































































































































































































































































































































import {Component, Prop, Watch} from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import MetaValuation from '@/views/MetaValuation.vue';
import MetaCompany from '@/views/MetaCompany.vue';
import MetaCompetitors from '@/views/MetaCompetitors.vue';
import MetaClosingMeeting from '@/views/MetaClosingMeeting.vue';
import MetaPreClosingMeeting from '@/views/MetaPreClosingMeeting.vue';
import MetaFutureMeeting from '@/views/MetaFutureMeeting.vue';
import MetaYearEndMeeting from '@/views/MetaYearEndMeeting.vue';
import MetaYearReview from '@/views/MetaYearReview.vue';
import {CompanyDocument} from '@/store/models';
import axios from 'axios';
import * as api from '@/store/api';
import UserSelection from '@/components/UserSelection.vue';
import MetaCashFlow from '@/views/MetaCashFlow.vue';
import MetaFlexible from '@/views/MetaFlexible.vue';
import MetaIndustryAnalysis from '@/views/MetaIndustryAnalysis.vue';
import MetaCompetitorAnalysis from '@/views/MetaCompetitorAnalysis.vue';
import MetaWebCashflowreport from '@/views/MetaWebCashflowreport.vue';
import MetaDeck from '@/views/MetaDeck.vue';

@Component({
  components: {
    MetaDeck,
    MetaWebCashflowreport,
    MetaCompetitorAnalysis,
    MetaIndustryAnalysis,
    MetaFlexible,
    MetaCashFlow,
    UserSelection,
    MetaValuation,
    MetaCompany,
    MetaCompetitors,
    MetaClosingMeeting,
    MetaPreClosingMeeting,
    MetaFutureMeeting,
    MetaYearEndMeeting,
    MetaYearReview,
  },
})
export default class CardDocuments extends CompanyMixin {
  @Prop() readonly kind!: any;

  selectedModel: any = {};
  downloading: boolean = false;
  showAddUser: boolean = false;

  @Watch('documentsOrTemplates', {immediate: true, deep: true})
  onDocumentsChanged() {
    if (
        this.selected &&
        this.selected.DocumentId === user.selectedDocument &&
        this.selected.Id !== user.selectedDocumentBlob
    ) {
      this.selectedModel = {};
      return;
    }

    if (this.documentsOrTemplates && !this.selected) {
      if (user.selectedDocument) {
        for (const doc of this.documentsOrTemplates) {
          if (doc.DocumentId === user.selectedDocument) {
            this.selectedModel = doc;
            return;
          }
        }
      }
    }

    if (this.documentsOrTemplates.length > 0) {
      this.selectedModel = this.documentsOrTemplates[0];
    }
  }

  @Watch('selected', {immediate: true, deep: true})
  async onSelectionChanged() {
    if (this.selected) {
      await user.setSelectedDocument(this.selected.DocumentId);
      await user.setSelectedDocumentBlob(this.selected.Id);
    }
  }

  getTitle(data: any) {
    const type = data.Type;
    const subType = data.SubType;

    switch (type) {
      case 'company': {
        return 'Bolagsanalys';
      }
      case 'competitors': {
        return 'Konkurrentjämförelse';
      }
      case 'valuation': {
        return 'Förenklad kassaflödesvärdering';
      }
      case 'closingmeeting': {
        return 'Bokslutsmöte';
      }
      case 'preclosingmeeting': {
        return 'Inför Bokslut';
      }
      case 'futuremeeting': {
        return 'Framtidsmöte';
      }
      case 'yearendmeeting': {
        return 'Årsavslutsmöte';
      }
      case 'yearreview': {
        return 'Årsgenomgång';
      }
      case 'typed': {
        switch (subType) {
          case 'cashflow': {
            return 'Kassaflödesanalys';
          }
          case 'webreport_cashflow': {
            return 'Grundlig kassaflödesgenomgång';
          }
          case 'flexible': {
            return 'Flexibel Presentation';
          }
          case 'company': {
            return 'Bolagsanalys';
          }
          case 'industryAnalysis': {
            return 'Branschjämförelse';
          }
          case 'competitorAnalysis': {
            return 'Konkurrentjämförelse';
          }
          case 'preClosingMeeting': {
            return 'Inför Bokslut';
          }
        }
        break;
      }
      case 'deck-template': {
        return data.Name || data.Title;
      }
      case 'deck': {
        return data.Title;
      }
    }
    return type;
  }

  downloadPresentation() {
    if (!this.selected) {
      return '';
    }

    user.setFetchingData(true);
    user.setFetchingMessage('Genererar PDF...');
    // this.downloading = true;

    const uri = `/api/user/print/${this.selected.Id}/${
        this.selected.Data.Type
    }`;
    axios({
      method: 'get',
      url: uri,
      responseType: 'arraybuffer',
    })
        .then((response) => {
          user.setFetchingData(false);
          // this.downloading = false;
          this.forceFileDownload(response, 'Presentation.pdf');
        })
        .catch(() => {
          user.setFetchingData(false);
          // this.downloading = false;
          console.log('error occured');
        });
  }

  previewWebreport() {
    if (this.selected) {
      switch (this.selected.Data.SubType) {
        case 'webreport_cashflow': {
          window.open('/webreport/' + this.selected.Id + '?preview=true', '_blank');
          return;
        }
      }
    }
  }

  previewPresentation() {
    if (this.selected) {
      window.open('/shared/' + this.selected.Id + '/info', '_blank');
    }
  }

  gotoPresentation() {
    if (this.selected) {
      if (process.env.NODE_ENV !== '_development') {
        this.openFullscreen();
      }
      const r = this.$router;
      switch (this.selected.Data.Type) {
        case 'company': {
          r.push({
            name: 'presentation-company',
            params: {DocumentId: this.selected.Id},
          });
          break;
        }
        case 'typed': {
          r.push({
            name: 'presentation',
            params: {DocumentId: this.selected.Id},
          });
          break;
        }
        case 'competitors': {
          r.push({
            name: 'presentation-competitors',
            params: {DocumentId: this.selected.Id},
          });
          break;
        }
        case 'valuation': {
          r.push({
            name: 'presentation-valuation',
            params: {DocumentId: this.selected.Id},
          });
          break;
        }
        case 'closingmeeting': {
          r.push({
            name: 'presentation-closingmeeting',
            params: {DocumentId: this.selected.Id},
          });
          break;
        }
        case 'preclosingmeeting': {
          r.push({
            name: 'presentation-preclosingmeeting',
            params: {DocumentId: this.selected.Id},
          });
          break;
        }
        case 'futuremeeting': {
          r.push({
            name: 'presentation-futuremeeting',
            params: {DocumentId: this.selected.Id},
          });
          break;
        }
        case 'yearendmeeting': {
          r.push({
            name: 'presentation-yearendmeeting',
            params: {DocumentId: this.selected.Id},
          });
          break;
        }
        case 'yearreview': {
          r.push({
            name: 'presentation-yearreview',
            params: {DocumentId: this.selected.Id},
          });
          break;
        }
        case 'deck-template':
        case 'deck': {
          r.push({
            name: 'presentation-deck',
            params: {DocumentId: this.selected.Id},
          });
          break;
        }
      }
    }
  }

  download(template: string, fileName: string) {
    user.setFetchingData(true);
    user.setFetchingMessage('Genererar PDF...');
    // this.downloading = true;
    axios({
      method: 'get',
      url: this.targetUri(template),
      responseType: 'arraybuffer',
    })
        .then((response) => {
          user.setFetchingData(false);
          // this.downloading = false;
          this.forceFileDownload(response, fileName);
        })
        .catch(() => {
          user.setFetchingData(false);
          // this.downloading = false;
          console.log('error occured');
        });
  }

  targetUri(template: string) {
    if (!this.selected) {
      return '';
    }
    if (template === 'cashflowreport') {
      return `/api/pdf/document/cashflow/${this.selected.Id}`;
    } else if (template === 'companyreport') {
      return `/api/pdf/document/company/${this.selected.Id}`;
    } else if (template === 'notes') {
      return `/api/pdf/document/notes/${this.selected.Id}`;
    } else if (template === 'valuation') {
      return `/api/pdf/document/valuation/${this.selected.Id}`;
    } else {
      return `/api/user/render/${this.selected.Id}/${template}`;
    }
  }

  forceFileDownload(response: any, fileName: string) {
    const data = new Blob([response.data], {type: 'application/pdf'});

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(data, fileName);
      return;
    }

    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  open(path: string) {
    window.open(path, '_blank');
  }

  openFullscreen() {
    const elem: any = document.documentElement;
    if (elem.requestFullscreen) {
      return elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      return elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      return elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      return elem.msRequestFullscreen();
    }
  }

  duplicateDocument() {
    if (!this.selected) {
      return;
    }
    this.$router.push({
        name: 'template-based-on',
        params: {
          TemplateId: this.selected.Id,
        },
      });

  }

  editDocument() {
    if (!this.selected) {
      return;
    }
    if (this.sharedByOther && this.documentType === 'deck-template') {
      return;
    }
    if (this.selected.Data.Type === 'deck' || this.selected.Data.Type === 'deck-template') {
      this.$router.push({
        name: 'editpresentation',
        params: {DocumentId: this.selected.Id},
      });
    } else {
      this.$router.push({name: 'editdocument'});
    }
  }

  closeAddUser() {
    this.showAddUser = false;
  }

  async shareDocument(selectedUser: any) {
    this.showAddUser = false;
    if (selectedUser.value !== null) {
      const doc = {
        UserIdEx: selectedUser.value,
        DocumentId: user.selectedDocument,
        BlobId: user.selectedDocumentBlob,
      };
      await api.shareDocument(doc);
      this.selectedModel = {};
      await user.getUser('Delar dokument');
    }
  }

  async unshareDocument(userId: any) {
    const res = await this.$bvModal.msgBoxConfirm(
        'Vill du ta bort användaren?',
        {
          title: 'Bekräftelse',
          okTitle: 'Ja',
          cancelTitle: 'Nej',
          buttonSize: 'lg',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true,
        },
    );
    if (res && user.selectedDocument) {
      const doc = {
        UserIdEx: userId,
        DocumentId: user.selectedDocument,
      };
      await api.unshareDocument(doc);
      this.selectedModel = {};
      await user.getUser('Tar bort delning');
    }
  }

  async deleteDocument() {
    if (this.userIdEx) {
      return;
    }
    if (this.sharedByOther && this.documentType === 'deck-template') {
      return;
    }
    const res = await this.$bvModal.msgBoxConfirm(
        'Vill du ta bort dokumentet?',
        {
          title: 'Bekräftelse',
          okTitle: 'Ja',
          cancelTitle: 'Nej',
          buttonSize: 'lg',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true,
        },
    );
    if (res && user.selectedDocument) {
      await api.deleteDocument(user.selectedDocument);
      await user.setSelectedDocument(null);
      await user.setSelectedDocumentBlob(null);
      this.selectedModel = {};
      await user.getUser('Tar bort dokument');
    }
  }

  get selected(): CompanyDocument | undefined {
    if (this.selectedModel.Created) {
      return this.selectedModel;
    } else {
      return undefined;
    }
  }

  get pending() {
    return false;
  }

  get excluded(): string[] {
    const me = user.user ? user.user.UserId : '';
    const excluded = [me];
    if (this.selected && this.selected.SharedWith) {
      for (const u of this.selected.SharedWith) {
        excluded.push(u.UserId);
      }
    }
    return excluded;
  }

  get sharedByOther(): boolean {
    if (!this.selected) {
      return false;
    }
    const me = user.user ? user.user.UserId : '';
    return this.selected.SharedBy.UserId !== me;
  }

  get documentType() {
    if (!this.selected) {
      return '';
    }
    return this.selected.Data.Type;
  }

  get usesGt360(): boolean {
    const slides = this.selected && this.selected.Data && this.selected.Data.Slides;
    if (!Array.isArray(slides)) {
      return false;
    }
    return slides.some((slide: any) =>
      Array.isArray(slide.subSlides) &&
      slide.subSlides.some(
        (sub: any) => sub && sub.collectionId === 'grant-thornton-360',
      ),
    );
  }

  get userIdEx() {
    return user.activeExternalUser;
  }

  get thisHost() {
    return process.env.VUE_APP_HOST;
  }

  get isTemplates() {
    return this.kind === 'templates';
  }

  get documentsOrTemplates() {
    if (this.isTemplates) {
      return this.templates || [];
    } else {
      return this.documents || [];
    }
  }
}
